import React from 'react';

import { Body2 } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';
import { NBSP } from 'shared/constants/common';
import { ETestIds } from 'shared/constants/testIds';

import styles from './styles.css';

export interface IProgramCardTermHint {
  content: React.ReactNode;
  tooltip: React.ReactNode;
}

export const FamilyLoanAmountHintContent: React.FC = () => (
  <div className={styles['term-hint']} data-testid={ETestIds.FamilyLoanAmountHint}>
    <span className={styles['term-hint-text']}>до 6 млн ₽ в регионах</span>
    <span className={styles['term-hint-icon']}>
      <IconFunctionalInformationCircle16 color="icon-primary-default" />
    </span>
  </div>
);

export const FamilyLoanAmountHintTooltip: React.FC = () => (
  <ul className={styles['hint-tooltip-list']} data-testid={ETestIds.FamilyLoanAmountHintTooltip}>
    <li>
      <Body2>
        {`до 12 млн ${NBSP}₽ (включительно) – г.${NBSP}Москва, Московская область, г.${NBSP}Санкт-Петербург, Ленинградская области;`}
      </Body2>
    </li>
    <li>
      <Body2>{`до${NBSP}6 млн рублей${NBSP}(включительно) – для${NBSP}иных субъектов Российской Федерации.`}</Body2>
    </li>
  </ul>
);

export const familyLoanAmountHint: IProgramCardTermHint = {
  content: <FamilyLoanAmountHintContent />,
  tooltip: <FamilyLoanAmountHintTooltip />,
};
